import { render, staticRenderFns } from "./constructionQuality.vue?vue&type=template&id=15dd4152&scoped=true"
import script from "./constructionQuality.vue?vue&type=script&lang=js"
export * from "./constructionQuality.vue?vue&type=script&lang=js"
import style0 from "./constructionQuality.vue?vue&type=style&index=0&id=15dd4152&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dd4152",
  null
  
)

export default component.exports